import {weekdays} from './data'

class Events {
  constructor (el) {
    this.el = el
    this.calendar = this.el.querySelector('.js-events-calendar')
    this.buttonPrev = this.el.querySelector('.js-events-button-prev')
    this.buttonNext = this.el.querySelector('.js-events-button-next')
    this.title = this.el.querySelector('.js-events-calendar-title')
    this.weekdays = this.el.querySelector('.js-events-calendar-weekdays')
    this.table = this.el.querySelector('.js-events-calendar-table')
    this.locale = 'ua'
    this.langCode = ''
    this.date = new Date()
    this.month = this.date.getMonth()
    this.year = this.date.getFullYear()
    this.changeMonthEvent = new Event('month-changed');

    this.startDate = null
    this.endDate = null
    this.monthStartDate = null
    this.monthEndDate = null

    this.initDefaults()
  }

  initDefaults () {
    this.getLangCode()
    this.initCalendar(this.year, this.month)
    this.initEvents()
    this.onResize()
  }

  initEvents () {
    this.buttonNext.addEventListener('click', e => this.setNextMonth(e))
    this.buttonPrev.addEventListener('click', e => this.setPrevMonth(e))
    window.addEventListener('resize', () => this.onResize())
  }

  onResize () {
    if (window.innerWidth < 1308) {
      this.el.style.fontSize = 16 * ( window.innerWidth / 1308 ) + 'px'
    } else {
      this.el.style.fontSize = '16px'
    }
  }

  setNextMonth (e) {
    e.preventDefault()
    if (this.month < 11) {
      this.month++
    } else {
      this.month = 0
      this.year++
    }
    this.initCalendar(this.year, this.month)
    this.el.dispatchEvent(this.changeMonthEvent);
  }

  setPrevMonth (e) {
    e.preventDefault()
    if (this.month > 0) {
      this.month--
    } else {
      this.month = 11
      this.year--
    }
    this.initCalendar(this.year, this.month)
    this.el.dispatchEvent(this.changeMonthEvent);
  }

  getNextMonth () {
    let month = this.month
    let year = this.year
    if (month < 11) {
      month++
    } else {
      month = 0
      year++
    }

    return { year, month }
  }
  
  getPrevMonth () {
    let month = this.month
    let year = this.year
    if (month > 0) {
      month--
    } else {
      month = 11
      year--
    }

    return { year, month }
  }

  getNumeric (value) {
    return value < 10 ? `0${value}` : value
  }

  initCalendar (year, month) {
    const date = new Date(year, month)
    let table = ''
    let weekdaysTable = ''
    const titleValue = date.toLocaleString(this.langCode, {
      month: 'long',
      year: 'numeric'
    })

    // render title month + year
    this.title.innerHTML = titleValue

    //render weekdays
    weekdays[this.locale].forEach(el => {
      weekdaysTable += `<div>${el}</div>`
    })

    this.weekdays.innerHTML = weekdaysTable

    // render last days of prev month
    const prevYear = this.getPrevMonth().year
    const prevMonth = this.getPrevMonth().month
    const prevDate = new Date(prevYear, prevMonth)
    let prevDays = []

    while (prevDate.getMonth() == prevMonth) {
      prevDays.push(prevDate.getDate())
      prevDate.setDate(prevDate.getDate() + 1)
    }

    prevDays.splice(0, (prevDays.length - this.getDay(date)))

    for (let i = 0; i < this.getDay(date); i++) {
      table += `<div class="disabled js-prev-month" data-date="${prevYear + '-' + this.getNumeric(prevMonth + 1) + '-' + this.getNumeric(prevDays[i])}">${prevDays[i]}</div>`
    }

    const currentMonthDates = []

    // ячейки календаря с датами
    while (date.getMonth() == this.month) {
      const dayDate = this.year + '-' + this.getNumeric(this.month + 1) + '-' + this.getNumeric(date.getDate())
      table += `<div data-date="${dayDate}">` + date.getDate() + '</div>'
      currentMonthDates.push(dayDate)
      date.setDate(date.getDate() + 1)
    }

    this.monthStartDate = currentMonthDates[0]
    this.el.setAttribute('data-date', this.monthStartDate)
    this.monthEndDate = currentMonthDates[currentMonthDates.length - 1]

    // render first days of next month
    const nextYear = this.getNextMonth().year
    const nextMonth = this.getNextMonth().month
    const nextDate = new Date(nextYear, nextMonth)
    let nextDays = []

    while (nextDate.getMonth() == nextMonth) {
      nextDays.push(nextDate.getDate())
      nextDate.setDate(nextDate.getDate() + 1)
    }

    nextDays.splice(7 - this.getDay(date))

    if (this.getDay(date) != 0) {
      let counter = 0
      for (let i = this.getDay(date); i < 7; i++) {
        table += `<div class="disabled js-next-month" data-date="${nextYear + '-' + this.getNumeric(nextMonth + 1) + '-' + this.getNumeric(nextDays[counter])}">${nextDays[counter]}</div>`
        counter++
      }
    }

    this.table.innerHTML = table

    const days = this.table.querySelectorAll('div')

    this.startDate = days[0].getAttribute('data-date')
    this.endDate = days[days.length - 1].getAttribute('data-date')

  }

  getDay (date) {
    let day = date.getDay();
    if (day == 0) day = 7; // сделать воскресенье (0) последним днем
    return day - 1;
  }

  getLangCode () {
    this.locale = document.querySelector('html').getAttribute('lang')

    switch (this.locale) {
      case 'ua':
        this.langCode = 'uk-UA'
        break;
      case 'en':
        this.langCode = 'en-US'
        break;
      default:
        this.langCode = 'uk-UA'
        this.locale = 'ua'
        break;
    }
  }

  setActiveDays (payload) {
    const days = this.table.querySelectorAll('div')

    days.forEach(el => {
      payload.forEach(activeEl => {
        if (activeEl === el.getAttribute('data-date')) {
          el.classList.add('has-events')
        }
      })
    })
  }

  setActiveDay (date) {
    const days = this.table.querySelectorAll('div')

    days.forEach(el => {
      el.classList.remove('active')
      if (el.getAttribute('data-date') === date) {
        el.classList.add('active')
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-events')

  if (el) {
    window.calendar = new Events(el)
  }
})